import { LogoMark } from "./LogoMark";
import { useLanguage } from "@/i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();
  const links = [
    ["products", "#products"],
    ["enquiry", "#enquiry"],
    ["contact", "#contact"],
  ];

  return (
    <footer className="relative bg-white border-t border-[rgba(20,112,63,0.16)] overflow-hidden" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-10">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
          <div className="flex items-center gap-3">
            <LogoMark size={40} />
            <div className="leading-tight">
              <span className="font-serif-display text-xl text-[#12261A]">
                Aaravya <span className="text-[#14703F]">Impex</span>
              </span>
              <span className="block font-mono-spec text-[9px] tracking-[0.3em] uppercase text-[#8CA594]">
                Private Limited
              </span>
            </div>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3" data-testid="footer-links">
            {links.map(([key, href]) => (
              <a
                key={href}
                href={href}
                data-testid={`footer-link-${key}`}
                className="font-mono-spec text-[11px] tracking-[0.2em] uppercase text-[#8CA594] hover:text-[#14703F] transition-colors duration-300"
              >
                {t.footer.links[key]}
              </a>
            ))}
          </nav>
        </div>

        <div
          className="mt-16 select-none font-serif-display font-semibold leading-none tracking-tight text-[16.5vw] text-stroke-green whitespace-nowrap"
          aria-hidden="true"
          data-testid="footer-watermark"
        >
          AARAVYA
        </div>

        <div className="mt-10 pt-8 border-t border-[rgba(20,112,63,0.16)] flex flex-col sm:flex-row justify-between gap-3">
          <span className="font-mono-spec text-[10px] tracking-[0.18em] uppercase text-[#8CA594]">
            © {new Date().getFullYear()} {t.footer.rights}
          </span>
          <span className="font-mono-spec text-[10px] tracking-[0.18em] uppercase text-[#8CA594]">
            {t.footer.tagline}
          </span>
        </div>
      </div>
    </footer>
  );
};
